import React from "react";
import QuoteFromScratchContent from "../components/quotes/qfs-content";

const QFS = () => {
  return <QuoteFromScratchContent leadOrigin="qfs" />;
};

export default QFS;
